<!--
 * @Author: your name
 * @Date: 2020-08-31 20:09:57
 * @LastEditTime: 2022-11-08 16:28:35
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/CountrySelect/index.vue
-->
<style lang="sass" scoped>
::v-deep
  .van-overlay
    background-color: transparent

.popup
  height: 200px
  box-shadow: 0 0.13889rem 0.13889rem -0.08333rem rgb(0 0 0 / 20%), 0 0.22222rem 0.27778rem 0.02778rem rgb(0 0 0 / 14%), 0 0.08333rem 0.38889rem 0.05556rem rgb(0 0 0 / 12%)

.select_wrap
  height: 200px
  overflow: auto

  .item
    display: flex
    align-items: center
    padding: 0 15px
    height: 36px
    font-size: 14px
    color: rgba(0, 0, 0, .87)
    cursor: pointer

    &.choose
      color: var(--menu-primary-background-colour)
      background-color: rgba(0, 0, 0, .1)

    &.disable
      color: rgba(#000, .4)
      text-decoration: line-through
</style>

<template lang="pug">
div
  van-popup.popup(
    v-bind="$attrs"
    v-on="$listeners"
    position="bottom"
  )
    .select_wrap
      ul
        li.item(
          v-for="(item, index) in dataList"
          :key="index"
          :class="[{'disable': !item.available}, {'choose': item.value === data}, `${type}_item_${index}`]"
          @click="select(item)"
        ) {{ item.label }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import {
  _srcollToErrorDom
} from '@/utils/srcoll'

@Component({
  props: {
    show: Boolean, // Display conditions   // 控制是否显示
    data: [String, Number], // Selected data   // 选中的数据
    dataList: Array, // Data List   // 数据列表
    type: String, // Type time date   // 类型。包括 'time'、 'date'。
  },

  watch: {
    show(val) {
      if (val && this.data) {
        const index = this.dataList.findIndex(item => item.value === this.data)
        _srcollToErrorDom.bind(this)(`${this.type}_item_${index}`)
      }
    }
  },
})

class SelectBottomPopup extends Vue {
  /**
   * Click Options
   * @param val {String, Object} Selected option value
   */
  /**
   * 点击选项
   * @param val {String, Object} 点击的选项值
   */
  select(item) {
    if (!item.available) return
    this.$emit('select', item.value)
  }
}

export default SelectBottomPopup
</script>
